(function ($, Global) {
    var urlParams = new UrlParams();
    function AbonnementsPage() {
        // Déclaration class objet
    }
    var nbReadersList = ['1', '2', '5', '10', '15', '20', '20+'];

	AbonnementsPage.prototype.initEvents = function () {
		this.publishers();
	}

    AbonnementsPage.prototype.publishers = function () {
        $(document).ready(function () {
            var hash = $.URLHash();
            var params = urlParams.getParams();
            var $collapse = $('#collapse' + hash);
            var $collapsePublication = $('#collapsePublication');

            if (hash && hash.match(/tab/) && $collapsePublication.exists()) {
                showCollapse($collapsePublication);

                $('.nav-tabs a[href="#' + hash + '"]').tab('show');
            }
            else if ($collapse.exists()) {
                showCollapse($collapse);
            }
            else if (params.tab) {              
                if ($collapsePublication.exists()) {
                    showCollapse($collapsePublication);
                    $('.nav-tabs a[href="#tab' + params.tab + '"]').tab('show');
                }
            }
            else if (params.offer) {
                var $collapseOffer = $('#collapse' + params.offer);

                if ($collapseOffer.exists()) {
                    showCollapse($collapseOffer);
                }
            }
            buttonsNbReadersState();
            setTimeout(transformUrlSimulation, 500);
		});

		$(document).on('shown.bs.collapse', '.abo-item', function () {
			var target = $(this).find('.panel-heading').attr('data-target');
			var scrollTop = $(target).offset().top - $('.nav-fixed').height() - $(this).closest('.abo-item').find('.panel-heading').height() - 100;

			$('html, body').animate({
				scrollTop: scrollTop
			}, 'slow');
		});

		$(document).on('change', 'select[name="devisePME"]', function () {
			var form = $('.form-pme');
			var button = form.find('.btn-primary');
			var titreStrong = $('.advantages .bigger strong');

            button.prop('href', $(this).val());
            if ($(this).attr("data-format") == "Francais")
                titreStrong.html('30 ' + $(this).find('option:selected').text());
            else
                titreStrong.html($(this).find('option:selected').text() + ' 30');
        });

        // Fix pour les vieux Iphone (5S) sous Safari
        $('.list-offers .panel-default').on('click', handleBlockOffer);

        $(document).on('click', '.list-offers .panel-default', handleBlockOffer);

        function handleBlockOffer(ev) {
            ev.stopPropagation();

            var $this = $(this);

            if ($this.hasClass('in')) {
                $this.removeClass('in');
            } else {
                $this.addClass('in');
            }
        }


        $(document).on('click', '.abonnement-presentation .nb-readers button', function (e) {
            e.preventDefault();
            var newIndex;
            var $this = $(this);
            var isPositive = $this.hasClass('plus');
            var $nbReadersSelected = $('.abonnement-presentation .nb-readers strong');
            var nbReadersSelected = $nbReadersSelected.text();
            var indexSelected = nbReadersList.indexOf(nbReadersSelected);
            
            if (isPositive) {
                newIndex = ((indexSelected + 1) > (nbReadersList.length - 1)) ? indexSelected : (indexSelected + 1);
            } else {
                newIndex = ((indexSelected - 1) < 0) ? indexSelected : (indexSelected - 1);
            }

            transformUrlSimulation(newIndex);
            $nbReadersSelected.text(nbReadersList[newIndex]);
            buttonsNbReadersState();
        });       
    }

    function showCollapse($collapse) {
        $collapse.collapse('show');

        scrollTop = $collapse.offset().top - $('.nav-fixed').height() - $collapse.closest('.abo-item').find('.panel-heading').height() - 100;

        setTimeout(function () {
            $('html, body').animate({
                scrollTop: scrollTop
            }, 'slow');
        }, 500);
    }

    function transformUrlSimulation(i) {
        i = i || 0;
        var val;
        var $linkSimulation = $('.abonnement-presentation a.btn-primary');

        var noChangeLink = false;
        if ($.linkSimulation && $.linkSimulation.data("js") &&  $.linkSimulation.data("js") === "nochangelink") noChangeLink = true;

        if ($linkSimulation && $linkSimulation.exists() && noChangeLink===false) {
            var linkSimulation = $linkSimulation.attr('href').split('?')[0];

            if (i === (nbReadersList.length - 1)) {
                val = 100;
            } else {
                val = nbReadersList[i];
            }

            $linkSimulation.attr('href', linkSimulation + '?readers=' + val);
        }     
    }

    function buttonsNbReadersState() {
        var $nbReadersSelected = $('.abonnement-presentation .nb-readers strong');
        var nbReadersVal = $nbReadersSelected.text();

        $('.glyphicon-plus-sign, .glyphicon-minus-sign').removeClass('disable');

        if (nbReadersVal == nbReadersList[nbReadersList.length - 1]) {
            $('.glyphicon-plus-sign').addClass('disable');
        }
        if (nbReadersVal == nbReadersList[0]) {
            $('.glyphicon-minus-sign').addClass('disable');
        }
    }

	Global.AbonnementsPage = AbonnementsPage;
}(jQuery, window));